import { Injectable, inject } from '@angular/core';
import { SolutionsRequestQuery } from '@app/src/app/modules/solution/graphql/default/solutions.request.query';
import { SolutionByRequestQuery } from '@app/src/app/modules/solution/graphql/default/solution.by.request.query';
import { SolutionRequestQuery } from '@app/src/app/modules/solution/graphql/default/solution.request.query';
import { SolutionsPublicRequestQuery } from '@app/src/app/modules/solution/graphql/default/solutions.public.request.query';
import { SolutionRequestMutation } from '@app/src/app/modules/solution/graphql/default/solution.request.mutation';
import { SolutionExistsRequestQuery } from '@app/src/app/modules/solution/graphql/default/solution.exists.request.query';
import {
  buildPayload,
  DashboardGlobalConfigType,
  ItemNotFound,
} from '@ckmk/angular';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SolutionService {
  public readonly list = inject(SolutionsRequestQuery);

  public readonly single = inject(SolutionRequestQuery);

  public readonly manage = inject(SolutionRequestMutation);

  public readonly exists = inject(SolutionExistsRequestQuery);

  public readonly solution = inject(SolutionByRequestQuery);

  public readonly solutions = inject(SolutionsPublicRequestQuery);

  public constructor() {}

  public async isExists(
    route: ActivatedRouteSnapshot,
    config?: DashboardGlobalConfigType,
  ): Promise<boolean> {
    return this.exists
      .fetchQuery(
        buildPayload()
          .into('payload', (pl) =>
            pl.filters((filter) => {
              if (config) {
                filter.equalTo('id', route.params['solution']);
              } else {
                filter
                  .equalTo('active', true)
                  .equalTo('slug', route.params['solution'])
                  .concat('category', (subFilter) =>
                    subFilter
                      .equalTo('active', true)
                      .equalTo('slug', route.params['category']),
                  );
              }
            }),
          )
          .build(),
      )
      .then((value) => !!value);
  }

  public fetchBySlug(slug?: string | null, categorySlug?: string | null) {
    if (slug && categorySlug) {
      return this.solution
        .fetchQuery(this.buildSlugPayload(slug, categorySlug))
        .then((res) => {
          if (res instanceof ItemNotFound) {
            return null;
          }

          return res;
        });
    }

    return null;
  }

  public watchBySlug(slug?: string, categorySlug?: string): void {
    if (slug && categorySlug) {
      this.solution.watchQuery(this.buildSlugPayload(slug, categorySlug));
    }
  }

  protected buildSlugPayload(slug?: string, categorySlug?: string): any {
    if (slug && categorySlug) {
      return buildPayload()
        .into('payload', (builder) =>
          builder
            .setMultiple({
              includeCategory: true,
              includePicture: true,
              includeCover: true,
            })
            .filters((filter) =>
              filter
                .equalTo('active', true)
                .equalTo('slug', slug)
                .concat('category', (subFilter) =>
                  subFilter
                    .equalTo('active', true)
                    .equalTo('slug', categorySlug),
                ),
            ),
        )
        .build();
    }
  }
}
